import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { GuidesByFeatureQueryResult } from "@shared/sanity/types";

interface GuidesQueryParams {
  feature: string;
  page: number;
  limit: number;
}

interface UseOrderOptions
  extends Omit<
    UseQueryOptions<
      GuidesByFeatureQueryResult,
      Error,
      GuidesByFeatureQueryResult,
      ["guides", "feature", GuidesQueryParams]
    >,
    "queryKey" | "queryFn"
  > {
  queryParams: GuidesQueryParams;
}

export const useGuidesByFeature = (options: UseOrderOptions) => {
  const { queryParams } = options;

  return useSuspenseQuery({
    queryKey: ["guides", "feature", queryParams],
    queryFn: async ({ signal }): Promise<GuidesByFeatureQueryResult> => {
      const { feature } = queryParams;

      const response = await axiosInstance.get(`/guides/${feature}`, {
        signal,
        params: queryParams,
      });

      return response.data;
    },
    ...options,
  });
};
